import React from 'react';
import { Grid } from '@mui/material';
import PageTitle from 'components/header/PageTitle';
import CommonItemForm from 'components/common/CommonItemForm';

const AppSettings = () => {
    return (
        <div>
            <PageTitle color="primary.main" title="অ্যাপ সেটিংস" />
            <Grid container spacing={3} sx={{ mt: 1, px: { xs: 1, md: 2 } }}>
                <Grid item xs={12} md={6}>
                    <CommonItemForm
                        title="হেডার ও ফুটার"
                        itemKey="appBranding"
                        fields={[
                            { name: 'heading', label: 'হেডার টাইটেল (ই-বন্ধন)' },
                            { name: 'heading2', label: 'ফুটার - কলেজের নাম' },
                            { name: 'body', label: 'ফুটার - দ্বিতীয় লাইন (কুমিল্লা)' },
                        ]}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default AppSettings;
